// extracted by mini-css-extract-plugin
module.exports = {"title":"About_title__ezTei","list":"About_list__2wEoc","map":"About_map__2654T"};